import React, { ReactElement } from 'react';
import { NextSeo } from 'next-seo';
import { css } from '@emotion/react';
import theme from '@styles/theme';

import ShareHeader from './ShareHeader';

interface ILayout {
  head: {
    title: string;
    description: string;
    ogTitle: string;
    ogDescription: string;
    ogUrl: string;
    ogImage: string;
  };
  children: ReactElement | ReactElement[];
}

const ShareLayout = ({ children, head }: ILayout) => {
  return (
    <>
      <NextSeo
        title={head.title}
        description={head.description}
        openGraph={{
          title: head.title,
          description: head.description,
          url: head.ogUrl,
          images: [
            {
              url: head.ogImage,
              width: 800,
              height: 400,
            },
          ],
        }}
      />
      <ShareHeader />
      <main css={container}>{children}</main>
    </>
  );
};

const container = css`
  width: 800px;
  padding-top: 4em;
  background: ${theme.colors.white};

  .section-divider {
    width: 100%;
    height: 1em;
    background: ${theme.colors.gray200};
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    width: 100%;
  }
`;

export default ShareLayout;
